// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.entity-metadata-datetime-value{        \r\n    padding-top: 4px;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    padding-bottom: 16px;\n}\n.entity-metadata-enum-value{    \r\n    padding: 16px;\n}\n.entity-metadata-string-value{    \r\n    padding: 16px;\n}\r\n", ""]);
// Exports
module.exports = exports;
